export default __webpack_public_path__ + "static/media/icon-cloud-vm-round.8e11a7ed.svg";